import { cn } from "@generator/src/components/utils"

type Props = {
  onClickAway: () => void
  enabled?: boolean
  className?: string
  dim?: boolean
}

export function ClickAway(props: Props) {
  return (
    <div
      className={cn(
        "fixed outline inset-0 z-[40] transition-opacity",
        props.enabled
          ? "opacity-100 pointer-events-auto duration-700 delay-100"
          : "duration-500 opacity-0 pointer-events-none",
        props.dim && "bg-black/20",
        props.className,
      )}
      onClick={props.onClickAway}
    />
  )
}
